import { render, staticRenderFns } from "./AddNewAddress.vue?vue&type=template&id=58475ae0&scoped=true"
import script from "./AddNewAddress.vue?vue&type=script&lang=js"
export * from "./AddNewAddress.vue?vue&type=script&lang=js"
import style0 from "./AddNewAddress.vue?vue&type=style&index=0&id=58475ae0&prod&lang=scss&scoped=true"
import style1 from "./AddNewAddress.vue?vue&type=style&index=1&id=58475ae0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58475ae0",
  null
  
)

export default component.exports